"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.38,11a6.36,6.36,0,1,0,6.36,6.36A6.37,6.37,0,0,0,17.38,11Zm3.11,9.46a.27.27,0,0,1-.37,0l-3.18-2.92a.27.27,0,0,1-.09-.2V14.47a.27.27,0,1,1,.53,0v2.8l3.09,2.84A.27.27,0,0,1,20.49,20.48Z",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.79.72a.47.47,0,0,0-.47-.47H.72A.47.47,0,0,0,.26.72V5.87H21.79Z",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.3,10.78v-4H7.75v15h3.84a7.27,7.27,0,0,1,2.72-11Z",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.79,11.58V6.81H15.23v3.6a7.27,7.27,0,0,1,6.55,1.17Z",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.26,21.32a.47.47,0,0,0,.47.47H6.81v-15H.26Z",
    fill: "#004865"
  }));
};

exports["default"] = _default;